<template>
  <div class="box p-3">
    <div class="d-flex justify-content-center flex-column align-items-center">
      <h3 class="title" >Empresa</h3>
      <span class="span_company">* soma de todos os usuários para gerar a nota/média</span>
    </div>
    <table class="table table-borderless">
      <thead>
        <tr>
          <th class="line" scope="col"><div class="head">Company</div></th>
          <th scope="col"><div class="head">Vote</div></th>
        </tr>
      </thead>
      <tbody class="overflow-auto">
        <tr v-for="(vote, index) of votes" :key="index">
          <td @click="$emit('select_company_vote', vote.company)" class="line companyName">{{vote.companyName}}</td>
          <td>{{vote.average}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    votes: {
      type: Array
    }
  }
}
</script>

<style scoped>

table {
  text-align: center;
  color: #8d8f92;
}

td {
  width: 150px;
}

.head {
  border: 1px solid #8d8f92;
  border-radius: 20px;
  padding: 10px;
  color: #8d8f92;
}

.line {
  border-right: 3px solid #8d8f92;
}

.box {
  width: 100%;
  max-width: 510px;
  background-color: #e6e7e9;
  border-radius: 20px;
  overflow: auto;
  max-height: 40vh;
}

.title {
  background-color: #37aae1;
  border-radius: 20px;
  width: 100%;
  max-width: 140px;
  height: 100%;
  min-height: 40px;
  text-align: center;
  padding-top: 5px;
  color: #fff;
  font-size: 1.5em;
}

.span_company{
  font-size: 0.7em;
}

.companyName {
  cursor: pointer;
}

@media screen and (max-width: 1220px) {
  .box {
    margin-top: 130px;
  }
}
</style>